export const toFormData = function <T extends object>(data: T) {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (typeof value === 'number') {
            formData.append(key, value.toString())
        } else if (typeof value === 'string') {
            formData.append(key, value)
        } else if (value instanceof FileList) {
            formData.append(key, value[0])
        }
        else if (Array.isArray(value)) {
            formData.append(key, value[0])
        }
    })

    return formData
}